module.exports = __webpack_public_path__ + "static/img/csi1.4ff9333b.png";